import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navigation } from "@/components/sections/Navigation";
import { Footer } from "@/components/sections/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { ScrollToTop } from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import LegalNoticePage from "@/pages/LegalNoticePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import GonePage from "@/pages/GonePage";
import ContactRedirect from "@/pages/ContactRedirect";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App relative bg-soft text-ink">
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/legal-notice" element={<LegalNoticePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/contact" element={<ContactRedirect />} />
            <Route path="/terms-conditions" element={<GonePage />} />
            <Route path="/terms-conditions/*" element={<GonePage />} />
            <Route path="*" element={<GonePage />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <Toaster position="bottom-right" richColors closeButton />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
